module.exports = __webpack_public_path__ + "static/img/bridges04.e068cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/bridges04.jpg
// module id = OqIb
// module chunks = 0